export let state;
state = {
  timesheet: [
    {
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.timesheet.name",
      to: "/timesheets"
    },
    {
      text: "bread_crumb.timesheet.list",
      active: true
    }
  ],
  additional_timesheet: {
    list: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.additional_timesheet.name",
        to: "/additional-timesheet"
      }
      // {
      //   text: "bread_crumb.additional_timesheet.list",
      //   active: true
      // }
    ],
    approval_list: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.additional_timesheet.name",
        to: "/additional-timesheet"
      },
      {
        text: "bread_crumb.additional_timesheet.approval_list",
        active: true
      }
    ],
    approval: [
      {
        text: "bread_crumb.home",
        t0: "/"
      },
      {
        text: "bread_crumb.additional_timesheet.name",
        to: "/additional-timesheet"
      },
      {
        text: "bread_crumb.additional_timesheet.approval",
        active: true
      }
    ],
    detail: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.additional_timesheet.name",
        to: "/additional-timesheet"
      },
      {
        text: "bread_crumb.additional_timesheet.detail",
        active: true
      }
    ],
    update: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.additional_timesheet.name",
        to: "/additional-timesheet"
      },
      {
        text: "bread_crumb.additional_timesheet.update",
        active: true
      }
    ],
    create: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.additional_timesheet.name",
        to: "/additional-timesheet"
      },
      {
        text: "bread_crumb.additional_timesheet.create",
        active: true
      }
    ]
  },
  checkpoint: {
    create: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.checkpoint.name",
        to: "/checkpoint"
      },
      {
        text: "bread_crumb.checkpoint.create",
        active: true
      }
    ],
    see_review: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.checkpoint.name",
        to: "/checkpoint/see-review"
      },
      {
        text: "bread_crumb.checkpoint.create",
        active: true
      }
    ],
    interview: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.checkpoint.name",
        to: "/checkpoint/interview"
      },
      {
        text: "bread_crumb.checkpoint.interview",
        active: true
      }
    ],
    checkpoint_myself: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.checkpoint.name",
        to: "/checkpoint/myself"
      },
      {
        text: "bread_crumb.checkpoint.myself",
        active: true
      }
    ],
    checkpoint_list_pm: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.checkpoint.name",
        to: "/checkpoint/list-waiting-pm"
      },
      {
        text: "bread_crumb.checkpoint.list",
        active: true
      }
    ],
    checkpoint_pm: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.checkpoint.name",
        to: "/checkpoint/checkpoint-by-pm"
      },
      {
        text: "bread_crumb.checkpoint.review",
        active: true
      }
    ],
    checkpoint_list_dm: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.checkpoint.name",
        to: "/checkpoint/list-waiting-dm"
      },
      {
        text: "bread_crumb.checkpoint.list",
        active: true
      }
    ],
    checkpoint_list_interview: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.checkpoint.name",
        to: "/checkpoint/list-waiting-interview"
      },
      {
        text: "bread_crumb.checkpoint.interview",
        active: true
      }
    ],
    checkpoint_dm: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.checkpoint.name",
        to: "/checkpoint/checkpoint-by-dm"
      },
      {
        text: "bread_crumb.checkpoint.review",
        active: true
      }
    ],
    checkpoint_result_member: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.checkpoint.name",
        to: "/checkpoint/result"
      },
      {
        text: "bread_crumb.checkpoint.result",
        active: true
      }
    ],
    checkpoint_result_pm: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.checkpoint.name",
        to: "/checkpoint/result-check-point-pm"
      },
      {
        text: "bread_crumb.checkpoint.result",
        active: true
      }
    ],
    result_bod: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.checkpoint.name",
        to: "/checkpoint/result-dm-bod-ihr"
      },
      {
        text: "bread_crumb.checkpoint.result_bod",
        active: true
      }
    ]
  },
  overtime: {
    create: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.overtime.name",
        to: "/overtime-requests"
      },
      {
        text: "bread_crumb.overtime.create",
        active: true
      }
    ],
    update: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.overtime.name",
        to: "/overtime-requests"
      },
      {
        text: "bread_crumb.overtime.update",
        active: true
      }
    ],
    list: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.overtime.name",
        to: "/overtime-requests"
      }
    ],
    approval_list: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.overtime.name",
        to: "/overtime-requests"
      },
      {
        text: "bread_crumb.overtime.approval_list",
        active: true
      }
    ],
    approval: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.overtime.name",
        to: "/overtime-requests"
      },
      {
        text: "bread_crumb.overtime.approval",
        active: true
      }
    ],
    detail: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.overtime.name",
        to: "/overtime-requests"
      },
      {
        text: "bread_crumb.overtime.detail",
        active: true
      }
    ]
  },
  sabbatical: {
    create: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.sabbatical.name",
        to: "/sabbatical-leave-request"
      },
      {
        text: "bread_crumb.sabbatical.create",
        active: true
      }
    ],
    update: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.sabbatical.name",
        to: "/sabbatical-leave-request"
      },
      {
        text: "bread_crumb.sabbatical.update",
        active: true
      }
    ],
    list: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.sabbatical.name",
        to: "/sabbatical-leave-request",
        active: true
      }
    ],
    approval_list: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.sabbatical.name",
        to: "/sabbatical-leave-request"
      },
      {
        text: "bread_crumb.sabbatical.approval_list",
        active: true
      }
    ],
    approval: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.sabbatical.name",
        to: "/sabbatical-leave-request"
      },
      {
        text: "bread_crumb.sabbatical.approval",
        active: true
      }
    ],
    detail: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.sabbatical.name",
        to: "/sabbatical-leave-request"
      },
      {
        text: "bread_crumb.sabbatical.detail",
        active: true
      }
    ],
    statistical: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.sabbatical.name",
        to: "/sabbatical-leave-request"
      },
      {
        text: "bread_crumb.sabbatical.statistical",
        active: true
      }
    ]
  },
  compensate: {
    create: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.compensate.name",
        to: "/monthly-work-time-additional-request"
      },
      {
        text: "bread_crumb.compensate.create",
        active: true
      }
    ],
    update: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.compensate.name",
        to: "/monthly-work-time-additional-request"
      },
      {
        text: "bread_crumb.compensate.update",
        active: true
      }
    ],
    list: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.compensate.name",
        to: "/monthly-work-time-additional-request"
      },
      {
        text: "bread_crumb.compensate.list",
        active: true
      }
    ],
    approval_list: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.compensate.name",
        to: "/monthly-work-time-additional-request"
      },
      {
        text: "bread_crumb.compensate.approval_list",
        active: true
      }
    ],
    approval: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.compensate.name",
        to: "/monthly-work-time-additional-request"
      },
      {
        text: "bread_crumb.compensate.approval",
        active: true
      }
    ],
    detail: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.compensate.name",
        to: "/monthly-work-time-additional-request"
      },
      {
        text: "bread_crumb.compensate.detail",
        active: true
      }
    ]
  },
  skill: {
    create: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.skill.name",
        to: "/skill-sheet"
      },
      {
        text: "bread_crumb.skill.create",
        active: true
      }
    ]
  },
  note: [
    {
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.note",
      to: "/note/document"
    }
  ],
  seat: [
    {
      text: "bread_crumb.home",
      to: "/"
    },
    {
      text: "bread_crumb.seat.name",
      to: "seating-chart"
    }
  ],
  profile: [
    {
      text: "bread_crumb.home",
      to: "/information-profile"
    },
    {
      text: "bread_crumb.profile",
      active: true
    }
  ],
  redirect: [
    {
      text: "Redirect",
      active: true
    }
  ],
  new: {
    create: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.new.name",
        to: "/news"
      },
      {
        text: "bread_crumb.new.create",
        active: true
      }
    ],
    update: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.new.name",
        to: "/news"
      },
      {
        text: "bread_crumb.sabbatical.update",
        active: true
      }
    ],
    list: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.new.name",
        to: "/news"
      },
      {
        text: "bread_crumb.new.list",
        active: true
      }
    ]
  },
  project_management: {
    project_list: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.project_management.name",
        to: "/project-management"
      }
    ],
    update: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.project_management.name",
        to: "/project-management"
      },
      {
        text: "bread_crumb.project_management.update"
      }
    ],
    effort: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.project_management.name",
        to: "/project-management"
      },
      {
        text: "bread_crumb.project_management.effort"
      }
    ],
    review: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.project_management.name",
        to: "/project-management"
      },
      {
        text: "bread_crumb.project_management.review"
      }
    ],
    history: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.project_management.name",
        to: "/project-management"
      },
      {
        text: "bread_crumb.project_management.history"
      }
    ],
    activities: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.project_management.name",
        to: "/project-management"
      },
      {
        text: "bread_crumb.project_management.activities"
      }
    ],
    logwork_approval: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.project_management.name",
        to: "/project-management"
      },
      {
        text: "bread_crumb.project_management.logwork_approval",
        active: true
      }
    ]
  },
  //   add_skill: [
  //     {
  //       text: "bread_crumb.home",
  //       to: "/add-skill"
  //     }
  //   ],
  summerTrip: {
    vote: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.summertrip.vote",
        active: true
      }
    ],
    vote_chart: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.summertrip.vote_chart",
        active: true
      }
    ]
  },
  remote: {
    list: [
      {
        text: "bread_crumb.home",
        to: "/"
      },
      {
        text: "bread_crumb.remote.name",
        to: "/remote-request"
      }
    ]
  }
};

// getters
export const getters = {
  timesheet: state => state.timesheet,
  additionalTimesheetList: state => state.additional_timesheet.list,
  additionalTimesheetCreate: state => state.additional_timesheet.create,
  additionalTimesheetUpdate: state => state.additional_timesheet.update,
  additionalTimesheetDetail: state => state.additional_timesheet.detail,
  additionalTimesheetApprovalList: state =>
    state.additional_timesheet.approval_list,
  additionalTimesheetApproval: state => state.additional_timesheet.approval,
  overtimeList: state => state.overtime.list,
  overtimeCreate: state => state.overtime.create,
  overtimeUpdate: state => state.overtime.update,
  overtimeDetail: state => state.overtime.detail,
  overtimeApprovalList: state => state.overtime.approval_list,
  overtimeApproval: state => state.overtime.approval,
  sabbaticalList: state => state.sabbatical.list,
  sabbaticalCreate: state => state.sabbatical.create,
  sabbaticalUpdate: state => state.sabbatical.update,
  sabbaticalDetail: state => state.sabbatical.detail,
  sabbaticalApprovalList: state => state.sabbatical.approval_list,
  sabbaticalApproval: state => state.sabbatical.approval,
  sabbaticalStatistical: state => state.sabbatical.statistical,
  compensateList: state => state.compensate.list,
  compensateCreate: state => state.compensate.create,
  compensateUpdate: state => state.compensate.update,
  compensateDetail: state => state.compensate.detail,
  compensateApprovalList: state => state.compensate.approval_list,
  compensateApproval: state => state.compensate.approval,
  skillsheetCreate: state => state.skill.create,
  note: state => state.note,
  seat: state => state.seat,
  profile: state => state.profile,
  // checkpoint: state => state.checkpoint,
  checkpoint_list_interview: state =>
    state.checkpoint.checkpoint_list_interview,
  checkpoint_interview: state => state.checkpoint.interview,
  checkpoint_myself: state => state.checkpoint.checkpoint_myself,
  checkpoint_list_pm: state => state.checkpoint.checkpoint_list_pm,
  checkpoint_pm: state => state.checkpoint.checkpoint_pm,
  checkpoint_dm: state => state.checkpoint.checkpoint_dm,
  checkpoint_list_dm: state => state.checkpoint.checkpoint_list_dm,
  checkpoint_result_member: state => state.checkpoint.checkpoint_result_member,
  checkpoint_result_pm: state => state.checkpoint.checkpoint_result_pm,
  checkpoint_create: state => state.checkpoint.create,
  see_review: state => state.checkpoint.see_review,
  checkpoint_result_bod: state => state.checkpoint.result_bod,
  redirect: state => state.redirect,
  newList: state => state.new.list,
  newCreate: state => state.new.create,
  newUpdate: state => state.new.update,
  projectManagementList: state => state.project_management.project_list,
  projectManagementUpdate: state => state.project_management.update,
  projectManagementEffort: state => state.project_management.effort,
  projectManagementReview: state => state.project_management.review,
  projectManagementHistory: state => state.project_management.history,
  remoteRequestList: state => state.remote.list,
  projectManagementActivities: state => state.project_management.activities,
  projectManagementKickoff: state => state.project_management.kickoff,
  logWorkTimeline: state => state.logwork,
  logworkApproval: state => state.project_management.logwork_approval,
  summerTripVote: state => state.summerTrip.vote,
  summerTripVoteChart: state => state.summerTrip.vote_chart,
  shortLeaveRequest: () => [
    { text: "Home", to: "/" },
    { text: "Danh sách đơn đi muộn về sớm", active: true }
  ]
};
